module.exports = __webpack_public_path__ + "static/media/cat-2.6da59678.svg";